module.exports = __webpack_public_path__ + "static/media/phone-app.6d647b4e.png";